import { domainError } from '../errors.js';
import { err, ok } from '../result.js';
import { HORIZON_S } from '../fermentation/simulate.js';
/** Current event schema version (docs/contracts/history.md). */
export const EVENT_SCHEMA_VERSION = 1;
/**
 * Range bounds before contract 0.4.0 were raw numbers (an infinite one came back from JSON as
 * `null`). They become portable bounds; a finite number keeps its value (history.md).
 */
const upcastBound = (bound) => typeof bound === 'number'
    ? { kind: 'finite', value: bound }
    : bound === null
        ? { kind: 'beyondHorizon', horizonS: HORIZON_S }
        : bound;
const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
/** Tolerant of malformed input: backups are untrusted and checked later (backup-events). */
const upcastSnapshot = (snapshot) => {
    if (!isRecord(snapshot) || !isRecord(snapshot.estimates))
        return snapshot;
    return {
        ...snapshot,
        estimates: Object.fromEntries(Object.entries(snapshot.estimates).map(([id, estimate]) => [
            id,
            isRecord(estimate) && Array.isArray(estimate.range)
                ? { ...estimate, range: estimate.range.map(upcastBound) }
                : estimate,
        ])),
    };
};
/**
 * Brings a stored event to the current representation without reinterpreting business values.
 * Version 1 is the only version so far; newer versions are refused explicitly. Snapshot
 * estimate ranges are read in both representations and always rewritten as portable bounds.
 */
export const upcastEvent = (event) => event.schemaVersion === EVENT_SCHEMA_VERSION
    ? ok(event.payload.type === 'BakeStarted'
        ? {
            ...event,
            payload: { ...event.payload, snapshot: upcastSnapshot(event.payload.snapshot) },
        }
        : event)
    : err(domainError('UnsupportedEventVersion', `Event schema ${event.schemaVersion} is not supported`, {
        eventId: event.eventId,
        schemaVersion: event.schemaVersion,
    }));
//# sourceMappingURL=upcast.js.map